import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {CancelNovaAgentRunInput, CancelNovaAgentRunMutation} from './__generated__/CancelNovaAgentRunMutation.graphql';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

// Stops a run. Named by the run id the browser minted, so a Stop pressed before the server has
// recorded the run still reaches it: the server writes the run down as cancelled, and the run's own
// create then finds it and never calls the model. A run already finished is left as it was and
// comes back with `cancelled` false.
//
// `task` comes back so every control showing the task hears that it is no longer running, and
// whether it still has a conversation - stopping a task's first run leaves it with none.
const mutation = graphql`
	mutation CancelNovaAgentRunMutation($input: CancelNovaAgentRunInput!) {
		cancelNovaAgentRun(input: $input) {
			run {
				id
				status
				cancelled
			}
			task {
				id
				hasNovaConversation
				novaRunningRunId
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<CancelNovaAgentRunInput>,
	onSuccess?: RelayOnCompleted<CancelNovaAgentRunMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation<CancelNovaAgentRunMutation>(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
